import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, ButtonGroup, ButtonToolbar, Row, Col } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import notificationPopUp from '../../../../NotificationPopUp';

import TextInput from '../../../common/TextInput';
import SelectInput from '../../../common/SelectInput';
import CheckboxInput from '../../../common/checkBox/CheckboxInput';
import ConfirmationModal from '../../../common/ConfirmationModal';
import ActiveEditor from '../../../common/checkBox/ActiveEditor';
import WarrantyAllowanceModal from './WarrantyAllowanceModal';

import * as authenticationActions from '../../../../actions/authenticationActions';
import * as commonActions from '../../../../actions/commonActions';
import commonFunctions from '../../../../commonFunctions';
import * as warrantyActions from '../../../../actions/warrantyActions';

const createActiveEditor = (onUpdate, props) => (<ActiveEditor onUpdate={onUpdate} {...props} />);

class WarrantyPage extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            commonState: this.props.commonState,
            authenticationState: this.props.authenticationState,
            warranty: props.warranty,
            warrantyAllowanceModalShow: false,
            warrantyCoverageCapInModal: { warrantyAllowances: [] },
            warrantyCoverageCapDeleteModal: {
                show: false,
                dropRowKeysp: []
            },
            clonePrestazioneModal: {
                show: false
            }
        };

        if (!authenticationActions.verifyAuthentication(this.state.authenticationState, this.props.history)) {
            return;
        }

        this.clonePrestazioneModal = this.clonePrestazioneModal.bind(this);
        this.numberToItalianEuroFormat = this.numberToItalianEuroFormat.bind(this);
        this.updateWarrantyState = this.updateWarrantyState.bind(this);
        this.validate = this.validate.bind(this);
        this.saveWarranty = this.saveWarranty.bind(this);
        this.showHideClonePrestazioneModal = this.showHideClonePrestazioneModal.bind(this);
        this.showHideWarrantyCoverageCapDeleteModal = this.showHideWarrantyCoverageCapDeleteModal.bind(this);
        this.warrantyCoverageCapAfterSaveCell = this.warrantyCoverageCapAfterSaveCell.bind(this);
        this.warrantyCoverageCapConfirmDelete = this.warrantyCoverageCapConfirmDelete.bind(this);
        this.warrantyCoverageCapDelete = this.warrantyCoverageCapDelete.bind(this);
        this.warrantyCoverageCapInsert = this.warrantyCoverageCapInsert.bind(this);
        this.warrantyCoverageAllowance = this.warrantyCoverageAllowance.bind(this);
        this.warranttAllowanceShowHideModal = this.warranttAllowanceShowHideModal.bind(this);
        this.warrantyAllowanceDelete = this.warrantyAllowanceDelete.bind(this);
        this.warranttAllowanceInsert = this.warranttAllowanceInsert.bind(this);
        this.warrantyCoverageCapInsertButton = this.warrantyCoverageCapInsertButton.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.commonState !== prevState.commonState || nextProps.authenticationState !== prevState.authenticationState)
            return Object.assign({}, prevState, { authenticationState: nextProps.authenticationState, commonState: nextProps.commonState });
        return null;
    }

    componentDidMount() {
        if (this.state.warranty.id > -1) {
            this.props.actions.loadWarranty(this.state.warranty.id).then((warranty) => {
                this.setState(Object.assign({}, this.state, { warranty }));
            }).catch(error => {
                notificationPopUp.error(error);
            });
        }
        if (!this.state.commonState.configuration || this.state.commonState.configuration.cities === null || this.state.commonState.configuration.cities.length === 0) {
            this.props.commonActions.loadConfiguration().then(() => {
            }).catch(error => {
                notificationPopUp.error('Problemi nel caricamento della configurazione base');
            });
        }
    }

    updateWarrantyState(event) {
        const warranty = Object.assign({}, this.state.warranty);
        warranty[event.target.name] = event.target.value;
        var app = Object.assign({}, this.state, { warranty: warranty });
        this.setState(app);
    }

    saveWarranty() {
        if (this.validate()) {
            this.props.actions.saveWarranty(this.state.warranty).then((newWarranty) => {
                this.setState(Object.assign({}, this.state, { warranty: newWarranty }));
                notificationPopUp.success('Prestazione ' + newWarranty.name + ' Salvata');
            }).catch(error => {
                notificationPopUp.error(error);
            });
        }
    }

    validate() {
        if (!_.isNil(this.state.warranty.warrantyCoverageCaps) && this.state.warranty.warrantyCoverageCaps.length > 0) {
            if (this.state.warranty.warrantyCoverageCaps.filter(x => x.isActive).length === 0) {
                notificationPopUp.warning('La Prestazione NON può essere salvata perchè ha bisogno di almeno un massimale Attivo');
                return false;
            }

            return true;
        }
        notificationPopUp.warning('La Prestazione NON può essere salvata perchè ha bisogno di almeno un massimale ');
        return false;
    }

    warrantyCoverageCapAfterSaveCell(row, cellName, cellValue) {
        const warranty = Object.assign({}, this.state.warranty);
        var selectedCoverageCap = warranty.warrantyCoverageCaps.filter(item => item.id === row.id)[0];

        if (cellName === 'isActive') {
            selectedCoverageCap[cellName] = cellValue;
        } else {
            selectedCoverageCap[cellName] = commonFunctions.numberStringItalianToUsNumber(cellValue);

            // AnnualValue Calculation this is just for the User cos WE RECALCULATE IT ON THE SERVER SIDE
            selectedCoverageCap.annualValue = _.toNumber(selectedCoverageCap.annualNetValue) +
                (_.toNumber(selectedCoverageCap.annualNetValue) * _.toNumber(selectedCoverageCap.taxPercentage) / 100) +
                (_.toNumber(selectedCoverageCap.annualNetValue) * _.toNumber(selectedCoverageCap.forwelfareRights) / 100) +
                _.toNumber(selectedCoverageCap.rights);
            selectedCoverageCap.annualValue = selectedCoverageCap.annualValue / (100 - _.toNumber(selectedCoverageCap.sebRights)) * 100;

            if (_.isNaN(selectedCoverageCap.annualValue))
                selectedCoverageCap.annualValue = '===';
        }

        var app = Object.assign({}, this.state, { warranty: warranty });
        this.setState(app);
    }

    clonePrestazioneModal() {
        this.props.actions.cloneWarranty(this.state.warranty.id).then((clonedWarrantyId) => {
            notificationPopUp.info('Prestazione Clonata');
            this.showHideClonePrestazioneModal();
            this.props.history.goBack();
        }).catch(error => {
            notificationPopUp.error(error);
        });
    }

    showHideClonePrestazioneModal() {
        const clonePrestazioneModal = Object.assign({}, this.state.clonePrestazioneModal);
        clonePrestazioneModal.show = !clonePrestazioneModal.show;
        this.setState(Object.assign({}, this.state, { clonePrestazioneModal }));
    }

    showHideWarrantyCoverageCapDeleteModal(dropRowKeys) {
        const warrantyCoverageCapDeleteModal = Object.assign({}, this.state.warrantyCoverageCapDeleteModal);
        warrantyCoverageCapDeleteModal.show = !warrantyCoverageCapDeleteModal.show;
        warrantyCoverageCapDeleteModal.dropRowKeysp = dropRowKeys;
        this.setState(Object.assign({}, this.state, { warrantyCoverageCapDeleteModal }));
    }

    warrantyCoverageCapConfirmDelete(next, dropRowKeys) {
        this.showHideWarrantyCoverageCapDeleteModal(dropRowKeys);
    }

    warrantyCoverageCapDelete(ids) {
        const warranty = Object.assign({}, this.state.warranty);
        const warrantyCoverageCapDeleteModal = Object.assign({}, this.state.warrantyCoverageCapDeleteModal);
        warrantyCoverageCapDeleteModal.show = !warrantyCoverageCapDeleteModal.show;
        warrantyCoverageCapDeleteModal.dropRowKeysp = [];
        var newCovs = warranty.warrantyCoverageCaps.filter(item => ids.indexOf(item.id) < 0);
        warranty.warrantyCoverageCaps = newCovs;
        var app = Object.assign({}, this.state, { warranty, warrantyCoverageCapDeleteModal });
        this.setState(app);
    }

    warrantyCoverageCapInsert() {
        const warranty = Object.assign({}, this.state.warranty);

        var last = _.last(warranty.warrantyCoverageCaps.filter(x => x.id < 0));
        var newId = -1;
        if (last != null)
            newId = last.id - 1;

        warranty.warrantyCoverageCaps.push({
            id: newId,
            name: '',
            annualNetValue: 0,
            taxPercentage: 0,
            annualValue: 0,
            coverageCap: 0,
            rights: 0,
            forwelfareRights: 0,
            sebRights: 0, isActive: true, warrantyAllowances: []
        });
        var app = Object.assign({}, this.state, { warranty: warranty });
        this.setState(app);
    }

    warrantyCoverageAllowance(cell, row) {
        return (
            <center>
                <button type="button" className="btn btn-info react-bs-table-add-btn " onClick={() => this.warranttAllowanceShowHideModal(row.id)}>Franchigie</button>
            </center>
        );
    }

    warrantyCoverageActive(cell, row) {
        return (
            <CheckboxInput name='isActive' label='' disabled value={cell} />
        );
    }

    warranttAllowanceShowHideModal(warrantyCovCapId) {
        let warrantyCoverageCapInModal = { warrantyAllowances: [] };
        const warranty = Object.assign({}, this.state.warranty);
        if (_.isNumber(warrantyCovCapId)) {
            warrantyCoverageCapInModal = Object.assign({}, this.state.warranty.warrantyCoverageCaps.filter(x => x.id === warrantyCovCapId)[0]);
        } else {
            warranty.warrantyCoverageCaps.filter(x => x.id === this.state.warrantyCoverageCapInModal.id)[0].warrantyAllowances = this.state.warrantyCoverageCapInModal.warrantyAllowances;
        }

        this.setState(Object.assign({}, this.state, { warranty: warranty }, { warrantyAllowanceModalShow: !this.state.warrantyAllowanceModalShow, warrantyCoverageCapInModal: warrantyCoverageCapInModal }));
    }

    warrantyAllowanceDelete(ids) {
        const warrantyCoverageCapInModal = Object.assign({}, this.state.warrantyCoverageCapInModal);
        var newAllowances = warrantyCoverageCapInModal.warrantyAllowances.filter(item => ids.indexOf(item.id) < 0);
        warrantyCoverageCapInModal.warrantyAllowances = newAllowances;
        var app = Object.assign({}, this.state, { warrantyCoverageCapInModal: warrantyCoverageCapInModal });
        this.setState(app);
    }

    warranttAllowanceInsert() {
        const warrantyCoverageCapInModal = Object.assign({}, this.state.warrantyCoverageCapInModal);

        var last = _.last(warrantyCoverageCapInModal.warrantyAllowances.filter(x => x.id < 0));
        var newId = -1;
        if (last != null)
            newId = last.id - 1;

        warrantyCoverageCapInModal.warrantyAllowances.push({ id: newId, allowance: 0, percentageDiscount: 0, uncovered: 0, warrantyWithDiscount: 0 });
        var app = Object.assign({}, this.state, { warrantyCoverageCapInModal: warrantyCoverageCapInModal });
        this.setState(app);
    }

    warrantyCoverageCapInsertButton() {
        return (<button type="button" className="btn btn-info react-bs-table-add-btn" onClick={this.warrantyCoverageCapInsert}>
            <span><i className="glyphicon glyphicon-plus"></i> Aggiungi</span>
        </button>);
    }

    numberToItalianEuroFormat(cell, row) {
        return commonFunctions.numberToItalianEuroFormat(cell);
    }

    render() {
        const companies = this.props.commonState.configuration.companies.map(
            (value) => {
                return { value: value.id, text: value.name };
            }
        );

        const warrantyTypes = [{ value: -1, text: '---' }, { value: 1, text: 'Assistenza' }, { value: 2, text: 'Rischio' }];

        const warrantyCoverageCapCellEditProp = {
            mode: 'click',
            blurToSave: true,
            afterSaveCell: this.warrantyCoverageCapAfterSaveCell
        };

        const warrantyCoverageCapSelectRowProp = {
            mode: 'checkbox'
        };

        const warrantyCoverageCapGridOptions = {
            deleteText: 'Elimina',
            handleConfirmDeleteRow: this.warrantyCoverageCapConfirmDelete,
            insertBtn: this.warrantyCoverageCapInsertButton
        };

        return (
            <div className="container">
                <h1>{this.state.warranty.name}</h1>
                <Row>
                    <Col sm={12}>
                        <button className='btn btn-primary' onClick={() => this.props.history.goBack()} style={{ marginBottom: 10 }} ><span className='glyphicon glyphicon-arrow-left'></span> Indietro</button>
                        <div className="panel panel-default x-panel">
                            <div className="panel-heading">Prestazione: {this.state.warranty.name}</div>
                            <div className="panel-body">
                                <Row>
                                    <Col sm={10} mdOffset={0}>
                                        <TextInput
                                            disabled={this.state.warranty.lockedOut ? 'disabled' : ''}
                                            name="name"
                                            label="Nome"
                                            value={this.state.warranty.name}
                                            onChange={this.updateWarrantyState} />
                                        <TextInput
                                            disabled={this.state.warranty.lockedOut ? 'disabled' : ''}
                                            name="code"
                                            label="Codice"
                                            value={this.state.warranty.code}
                                            onChange={this.updateWarrantyState} />
                                        <SelectInput
                                            disabled={this.state.warranty.lockedOut}
                                            name="companyId"
                                            label="Compagnia"
                                            defaultOptionText=""
                                            defaultOptionValue={-1}
                                            value={this.state.warranty.companyId}
                                            options={companies}
                                            onChange={this.updateWarrantyState} />
                                        <SelectInput
                                            // disabled={this.state.warranty.lockedOut}
                                            name="idWarrantyType"
                                            label="Tipo Prestazione"
                                            value={this.state.warranty.idWarrantyType ? this.state.warranty.idWarrantyType + '' : ''}
                                            options={warrantyTypes}
                                            onChange={this.updateWarrantyState} />
                                        <CheckboxInput
                                            disabled={this.state.warranty.lockedOut}
                                            name='isActive'
                                            label='Attiva'
                                            value={this.state.warranty.isActive}
                                            onChange={this.updateWarrantyState} />
                                        <CheckboxInput
                                            disabled={this.state.warranty.lockedOut}
                                            name='pagaTuttoAEmissione'
                                            label='Paga tutto in Emissione'
                                            value={this.state.warranty.pagaTuttoAEmissione}
                                            onChange={this.updateWarrantyState} />
                                        <br />
                                    </Col>
                                </Row>
                                <h3>Massimali</h3>
                                <BootstrapTable data={this.state.warranty.warrantyCoverageCaps} options={warrantyCoverageCapGridOptions} deleteRow={!this.state.warranty.lockedOut}
                                    cellEdit={warrantyCoverageCapCellEditProp} selectRow={this.state.warranty.lockedOut ? {} : warrantyCoverageCapSelectRowProp} insertRow={!this.state.warranty.lockedOut}>
                                    <TableHeaderColumn dataField='id' isKey hidden>Id</TableHeaderColumn>
                                    <TableHeaderColumn dataField='annualNetValue' editable={!this.state.warranty.lockedOut} dataFormat={this.numberToItalianEuroFormat}>Valore Netto</TableHeaderColumn>
                                    <TableHeaderColumn dataField='taxPercentage' editable={!this.state.warranty.lockedOut}>% Imposte</TableHeaderColumn>
                                    <TableHeaderColumn dataField='forwelfareRights' editable={!this.state.warranty.lockedOut}>% GrifoHealth</TableHeaderColumn>
                                    <TableHeaderColumn dataField='rights' editable={!this.state.warranty.lockedOut}>Diritti</TableHeaderColumn>
                                    <TableHeaderColumn dataField='sebRights' editable={!this.state.warranty.lockedOut}>% Teseo</TableHeaderColumn>
                                    <TableHeaderColumn dataField='coverageCap' editable={!this.state.warranty.lockedOut} dataFormat={this.numberToItalianEuroFormat}>Massimale</TableHeaderColumn>
                                    <TableHeaderColumn dataField='annualValue' editable={false} dataFormat={this.numberToItalianEuroFormat}>Valore Lordo</TableHeaderColumn>
                                    <TableHeaderColumn dataField='isActive' editable={!this.state.warranty.lockedOut} dataFormat={this.warrantyCoverageActive}
                                        customEditor={{ getElement: createActiveEditor }}>Attiva</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={this.warrantyCoverageAllowance} editable={false}>Franchigie</TableHeaderColumn>
                                </BootstrapTable>
                                <Row>
                                    <Col md={12} style={{ marginTop: 20 }}>
                                        <ButtonToolbar>
                                            <ButtonGroup>
                                                {this.state.warranty.lockedOut ? <Button
                                                    className="btn btn-primary"
                                                    onClick={this.saveWarranty}><span className='glyphicon glyphicon-floppy-disk'></span> Salva</Button> : <Button
                                                        className="btn btn-primary"
                                                        onClick={this.saveWarranty}><span className='glyphicon glyphicon-floppy-disk'></span> Salva</Button>}
                                                {authenticationActions.canICloneWarranty(this.state.authenticationState) ?
                                                    <Button bsStyle='success' onClick={() => this.showHideClonePrestazioneModal()}>
                                                        <span className='glyphicon glyphicon-duplicate'></span> Clona la Prestazione</Button> : ''}
                                            </ButtonGroup>
                                        </ButtonToolbar>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                </Row>
                <WarrantyAllowanceModal authenticationState={this.state.authenticationState}
                    warranty={this.state.warranty}
                    warrantyCoverageCap={this.state.warrantyCoverageCapInModal} warrantyAllowanceModalShow={this.state.warrantyAllowanceModalShow}
                    toggle={this.warranttAllowanceShowHideModal}
                    warrantyAllowanceDelete={this.warrantyAllowanceDelete} warranttAllowanceInsert={this.warranttAllowanceInsert} />
                <ConfirmationModal
                    title='Conferma Eliminazione Prestazione'
                    message={'Sei sicuro di voler eliminare le Prestazioni selezionate?'}
                    show={this.state.warrantyCoverageCapDeleteModal.show}
                    showHide={this.showHideWarrantyCoverageCapDeleteModal}
                    action={() => this.warrantyCoverageCapDelete(this.state.warrantyCoverageCapDeleteModal.dropRowKeysp)}
                    commonState={this.state.commonState}
                />
                <ConfirmationModal
                    title='Clona Prestazione'
                    message={'Sei sicuro di voler clonare la Prestazione ?'}
                    show={this.state.clonePrestazioneModal.show}
                    showHide={this.showHideClonePrestazioneModal}
                    action={this.clonePrestazioneModal}
                    commonState={this.state.commonState}
                />
            </div>
        );
    }
}

WarrantyPage.propTypes = {
    authenticationState: PropTypes.object.isRequired,
    commonState: PropTypes.object.isRequired,
    warranty: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    const warranty = { id: ownProps.match.params.id, idWarrantyType: -1, name: '', code: '', companyId: '', isActive: true, warrantyCoverageCaps: [] };

    return {
        commonState: state.commonState,
        authenticationState: state.authenticationState,
        warranty: warranty
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(warrantyActions, dispatch),
        commonActions: bindActionCreators(commonActions, dispatch),
        authenticationActions: bindActionCreators(authenticationActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WarrantyPage);
